import React, { FC } from 'react'

import { MenuEntryContentFragment } from '../../../../graphql/gatsby'
import { CategoriesList } from '../CategoriesList'
import { MenuEntryLibraryResource } from './MenuEntryLibraryResource'
import { MenuEntryProducts } from './MenuEntryProducts'
import { MenuEntryStaticContent } from './MenuEntryStaticContent'

export interface MenuEntryContentProps {
  content?: MenuEntryContentFragment | null
}

export const MenuEntryContent: FC<MenuEntryContentProps> = ({ content }) => {
  if (!content) {
    return null
  }
  switch (content.contentType) {
    case 'static':
      return content.staticContent ? (
        <MenuEntryStaticContent staticCardContent={content.staticContent} />
      ) : null
    case 'products':
      return content.products ? (
        <div className="flex flex-col w-full h-full">
          <h3>{content.products.title}</h3>
          <div className="flex flex-row gap-5 w-full h-full overflow-x-auto pr-6 lg:pr-14 items-stretch">
            <MenuEntryProducts sanityProducts={content.products.products} />
          </div>
        </div>
      ) : null
    case 'library':
      return content.libraryContent ? (
        <MenuEntryLibraryResource libraryContent={content.libraryContent.content} />
      ) : null
    case 'categories':
      return content.categories ? (
        <div className="flex flex-col w-full gap-6">
          <h3 className="text-base/[1.4] text-brand-navy-2 font-medium tracking-[0.03em] uppercase">
            {content?.categories?.title ?? 'Product Categories'}
          </h3>
          <CategoriesList categories={content?.categories?.categories} />
        </div>
      ) : null
    default:
      return null
  }
}
